import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ role, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return <div className="min-h-screen flex items-center justify-center text-[#7c2233]">Loading…</div>;
  }
  if (!user) {
    const roleParam = role ? `&role=${role === "family" ? "family" : role}` : "";
    return <Navigate to={`/auth?redirect=${encodeURIComponent(location.pathname)}${roleParam}`} replace />;
  }
  if (role && user.role !== role) {
    const dest = user.role === "admin" ? "/admin" : user.role === "caregiver" ? "/caregiver" : "/dashboard";
    return <Navigate to={dest} replace />;
  }
  return children;
}
